import { SharedActions } from './actions'
import { SharedGetters } from './getters'
import { SharedMutations } from './mutations'
import { SharedState } from './state'

export const SHARED_NAMESPACE = 'Shared'

export const Shared = {
  namespaced: true,
  state: SharedState,
  actions: SharedActions,
  mutations: SharedMutations,
  getters: SharedGetters,
}
